import {Counter, QueueItem, WindowWithMetrika} from './types';

export class RealCounter implements Counter {
    id: number;
    inited = false;
    queue: QueueItem[];

    constructor(id: number) {
        this.id = id;
        this.queue = [];

        if (this.getInstance()) {
            this.inited = true;
        } else {
            this.attachCallback();
        }
    }

    hit(...args: unknown[]) {
        this.callOrQueueMethod('hit', args);
    }

    params(...args: unknown[]) {
        this.callOrQueueMethod('params', args);
    }

    userParams(...args: unknown[]) {
        this.callOrQueueMethod('userParams', args);
    }

    reachGoal(...args: unknown[]) {
        this.callOrQueueMethod('reachGoal', args);
    }

    reachGoals(...args: unknown[]) {
        const goals = [args[0]];
        if (Array.isArray(goals)) {
            goals.forEach((goal) => {
                this.callOrQueueMethod('reachGoal', goal);
            });
        } else {
            this.callOrQueueMethod('reachGoal', args);
        }
    }

    private callOrQueueMethod(method: QueueItem['method'], args: unknown[]) {
        if (this.inited) {
            const instance = this.getInstance();
            instance[method](...args);
        } else {
            this.queue.push({method, args});
        }
    }

    private attachCallback() {
        (window as WindowWithMetrika)[`yaCounter${this.id}Callback`] = () => {
            this.inited = true;

            if (this.queue.length > 0) {
                this.queue.forEach(({method, args}) => this[method](...args));
                this.queue = [];
            }
        };
    }

    private getInstance() {
        return (window as WindowWithMetrika)[`yaCounter${this.id}`] as Counter;
    }
}
